import { StatusChipBg, StatusChipText } from '@labrav/react-components'
import { OfferStatus } from '../../modules/privateOffer/reducer'

export const getStatusAndLabelForChannelOffer = (status: OfferStatus) => {
  switch (status) {
    case OfferStatus.PRIVATE_OFFER_ACCEPTED:
      return {
        bgColor: StatusChipBg.GREEN,
        textColor: StatusChipText.GREEN,
        label: 'Accepted',
      }
    case OfferStatus.PRIVATE_OFFER_IN_DRAFT:
      return {
        bgColor: StatusChipBg.GRAY,
        textColor: StatusChipText.GRAY,
        label: 'Draft',
      }
    case OfferStatus.PRIVATE_OFFER_CREATION_IN_PROGRESS:
      return {
        bgColor: StatusChipBg.LIGHTBLUE,
        textColor: StatusChipText.LIGHTBLUE,
        label: 'In Progress',
      }
    case OfferStatus.PRIVATE_OFFER_EMAIL_SENT:
      return {
        bgColor: StatusChipBg.LIGHTBLUE,
        textColor: StatusChipText.LIGHTBLUE,
        label: 'Sent',
      }
    case OfferStatus.PRIVATE_OFFER_VIEWED:
      return {
        bgColor: StatusChipBg.LIGHTBLUE,
        textColor: StatusChipText.LIGHTBLUE,
        label: 'Viewed',
      }
    case OfferStatus.PRIVATE_OFFER_EXPIRED:
      return {
        bgColor: StatusChipBg.GRAY,
        textColor: StatusChipText.GRAY,
        label: 'Expired',
      }
    case OfferStatus.PRIVATE_OFFER_RESTRICTION_IN_PROGRESS:
      return {
        bgColor: StatusChipBg.YELLOW,
        textColor: StatusChipText.YELLOW,
        label: 'Cancellation in progress',
      }
    case OfferStatus.PRIVATE_OFFER_RESTRCITED:
      return {
        bgColor: StatusChipBg.RED,
        textColor: StatusChipText.RED,
        label: 'Cancelled',
      }
    case OfferStatus.PRIVATE_OFFER_FAILED:
      return {
        bgColor: StatusChipBg.RED,
        textColor: StatusChipText.RED,
        label: 'Failed',
      }
    default:
      return {
        bgColor: StatusChipBg.RED,
        textColor: StatusChipText.RED,
        label: 'Failed',
      }
  }
}
